var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 101,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.768 58.523c6.25 27.67-29.049 32.813-47.48 31.926-16.126 2.027-52.286 2.508-67.912-11.782-19.533-17.864-.601-57.011 33.355-69.174 33.957-12.162 74.224 14.443 82.037 49.03Z",
    fill: "#FBFBFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.94 12.601a1.049 1.049 0 0 0 1.139-.95l.687-7.573a1.049 1.049 0 1 0-2.09-.19l-.687 7.574a1.049 1.049 0 0 0 .95 1.14Z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.16 17.408a1.049 1.049 0 0 1-1.714-1.21l4.383-6.215a1.049 1.049 0 1 1 1.714 1.21l-4.382 6.215Z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.24 60.722c-1.434.75-2.604 1.968-3.067 3.519l-1.502 5.04a3.934 3.934 0 0 1-4.126 2.795l-10.19-.926a3.934 3.934 0 0 1-3.555-3.49l-.592-5.425c-.172-1.583-1.078-2.975-2.322-3.97-5.914-4.73-9.416-12.244-8.68-20.352C41.37 25.076 52.722 15.614 65.56 16.78c12.837 1.165 22.299 12.517 21.133 25.354-.745 8.208-5.654 15.035-12.453 18.588Z",
    fill: "url(#c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.247 44.245a1.048 1.048 0 0 0-.949-1.14l-7.574-.687a1.049 1.049 0 1 0-.19 2.09l7.574.687a1.048 1.048 0 0 0 1.139-.95Z",
    fill: "url(#d)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.222 37.107a1.05 1.05 0 0 1-.19 2.09l-7.573-.688a1.049 1.049 0 0 1 .19-2.09l7.573.688Z",
    fill: "url(#e)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.466 71.884a1.05 1.05 0 0 0 1.462-.253l4.382-6.215a1.049 1.049 0 1 0-1.714-1.21l-4.383 6.216a1.049 1.049 0 0 0 .253 1.462Z",
    fill: "url(#f)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.256 57.276a1.049 1.049 0 0 1-.88-1.904l6.902-3.191a1.049 1.049 0 0 1 .88 1.904l-6.902 3.191Z",
    fill: "url(#g)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.086 28.922c.243.526.866.755 1.392.512l6.903-3.192a1.049 1.049 0 0 0-.88-1.904l-6.903 3.192a1.049 1.049 0 0 0-.512 1.392Z",
    fill: "url(#h)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.202 61.258a1.049 1.049 0 1 1-1.209 1.714l-6.215-4.382a1.049 1.049 0 1 1 1.209-1.715l6.215 4.383Z",
    fill: "url(#i)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.232 24.486a1.049 1.049 0 0 0-.253-1.461l-6.215-4.383a1.049 1.049 0 1 0-1.21 1.715l6.216 4.382a1.049 1.049 0 0 0 1.462-.253Z",
    fill: "url(#j)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M79.847 73.93a1.049 1.049 0 1 1-1.904.88l-3.191-6.903a1.05 1.05 0 0 1 1.904-.88l3.191 6.903Z",
    fill: "url(#k)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.493 15.1a1.05 1.05 0 0 0 .512-1.393l-3.191-6.902a1.049 1.049 0 1 0-1.904.88l3.19 6.903a1.05 1.05 0 0 0 1.393.512Z",
    fill: "url(#l)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M51.406 26.4a21.505 21.505 0 0 0-5.635 8.616c-.24.682.168 1.407.864 1.605.695.197 1.415-.21 1.66-.89a18.924 18.924 0 0 1 12.64-11.771c.697-.196 1.152-.885 1.005-1.593-.148-.707-.842-1.165-1.54-.975a21.505 21.505 0 0 0-8.994 5.009Z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M52.319 72.718a1.311 1.311 0 0 1 1.424-1.187l13.581 1.233a1.311 1.311 0 0 1-.237 2.611l-13.58-1.233a1.311 1.311 0 0 1-1.188-1.424Zm.499 3.205a1.311 1.311 0 0 1 1.424-1.187l12.014 1.09a1.311 1.311 0 1 1-.237 2.612l-12.014-1.09a1.311 1.311 0 0 1-1.187-1.425Zm.76 3.229a1.311 1.311 0 0 1 1.424-1.187l9.925.9a1.311 1.311 0 1 1-.237 2.612l-9.925-.9a1.311 1.311 0 0 1-1.187-1.425Zm9.497 2.705c.577.053 1.014.57.832 1.12a4.598 4.598 0 0 1-1.42 2.085 4.59 4.59 0 0 1-7.483-2.893c-.08-.574.443-1.004 1.02-.952l7.051.64Z",
    fill: "#7A8189"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 28.519,
    y1: 4.22,
    x2: 91.393,
    y2: 92.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 28.519,
    y1: 4.22,
    x2: 91.393,
    y2: 92.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 28.519,
    y1: 4.22,
    x2: 91.393,
    y2: 92.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 28.519,
    y1: 4.22,
    x2: 91.393,
    y2: 92.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 28.519,
    y1: 4.22,
    x2: 91.393,
    y2: 92.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 28.519,
    y1: 4.22,
    x2: 91.393,
    y2: 92.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 28.519,
    y1: 4.22,
    x2: 91.393,
    y2: 92.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 28.519,
    y1: 4.22,
    x2: 91.393,
    y2: 92.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 28.519,
    y1: 4.22,
    x2: 91.393,
    y2: 92.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 28.519,
    y1: 4.22,
    x2: 91.393,
    y2: 92.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 28.519,
    y1: 4.22,
    x2: 91.393,
    y2: 92.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 28.519,
    y1: 4.22,
    x2: 91.393,
    y2: 92.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD375"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHintIcon);
export default __webpack_public_path__ + "static/media/hint-icon.8f6e5312b7ac888d2aec54fca1c43414.svg";
export { ForwardRef as ReactComponent };